import declare from "dojo/_base/declare";
import StringTranslated from "csi/heading/StringTranslated";
import Locale from "../Locale";
import { Context } from "csi/def/Context";

export = declare(StringTranslated, {
	/** return localized attribute name knowing the class owning the attribute */
	_getTranslatedText(ctx: Context, value: string): string {
		const { ReflectionAttributeId, ReflectionAttributeOwner } = ctx.getNode();
		return Locale.getTypeAttribute(ReflectionAttributeOwner, ReflectionAttributeId);
	},

	/** return localized attribute name by looking for the class from the Business Object at root of the view */
	_getTranslatedTextForFilter(ctx: Context, value: string): string {
		const { AttributeClassName, RootClassName } = ctx.view.getViewNode();
		const rootName = Locale.getTypeAttribute(RootClassName, value);
		const attrName = Locale.getTypeAttribute(AttributeClassName, value);
		return (rootName === value) ? attrName : rootName;
	},
});